import SignalRServiceFactory from './factory';

export const hub = SignalRServiceFactory;